<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h1 class="font-weight-bold text-uppercase">Denuncias de avaliações</h1>
        <hr class="linha-amarela" />
      </div>
    </div>
    <table class="table table-pedidos">
      <thead>
        <tr class="tr fs-12">
          <th width="20%">Profissional</th>
          <th width="30%">Avaliação</th>
          <th width="30%">Motivo da Denuncia</th>
          <th width="20%">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr class="tr fs-14" v-for="(dado, index) in dados" :key="index">
          <td>{{ dado.nome_fantasia }}</td>
          <td>{{ dado.avaliacao }}</td>
          <td>{{ dado.mensagem }}</td>
          <td>
            <a
              style="color: #6565fd; cursor: pointer"
              @click.prevent="execReport(1, dado.id)"
              class="ml-3"
              ><i class="fas fa-check-circle"></i
            ></a>
            <a
              style="color: #ea3535; cursor: pointer"
              @click.prevent="execReport(2, dado.avaliacao_id)"
              class="ml-3"
              ><i class="fas fa-trash"></i
            ></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'ReportProfessionals',
  mixins: [makeToast],
  data() {
    return {
      dados: null,
      data: {
        id: null,
        action: null,
      },
    };
  },
  created() {
    this.getReports();
  },
  methods: {
    execReport(action, id) {
      this.data.id = id;
      this.data.action = action;

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('professional/execReport', this.data)
        .then((response) => {
          const res = response.data;
          this.makeToast('Denuncia', res.message, res.type);
          this.getReports();
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Houve um problema ao buscar denuncias',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    getReports() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('professional/getReports')
        .then((response) => {
          this.dados = response.data;
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Houve um problema ao buscar denuncias',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
  },
};
</script>

<style></style>
